import React, { Fragment } from "react";
import Moment from "moment";
import { pdf, Page, Text, View, Document, StyleSheet, PDFViewer, Image } from "@react-pdf/renderer";
import TextField from "@material-ui/core/TextField";
import AutoCompleteInput from "@material-ui/lab/Autocomplete";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import yellow from "@material-ui/core/colors/yellow";
import {
	Button,
	Card,
	CardBody,
	Col,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row
} from "reactstrap";
import { Bar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import { authenticationService } from "../../../jwt/_services";
import certBG from "../../../assets/images/cert_white/cert_bg.png";
import certEdge from "../../../assets/images/cert_white/cert_edge.png";
import certEdgeRight from "../../../assets/images/cert_white/cert_edge_right.png";
import certGraphLeftEdge from "../../../assets/images/cert_white/cert_graph_left_edge.png";
import certGraphRightEdge from "../../../assets/images/cert_white/cert_graph_right_edge.png";
import certPart1 from "../../../assets/images/cert_white/cert_part1.png";
import certPart2 from "../../../assets/images/cert_white/cert_part2.png";
import certPart3 from "../../../assets/images/cert_white/cert_part3_nova.png";

const theme = createTheme({
	palette: {
		primary: yellow,
		type: "dark",
	},
});

var image1 = null;
var image2 = null;
var image3 = null;
var imageCount = 0;
var hasImages = false;

const certStyles = StyleSheet.create({
	page: { backgroundColor: '#ffffff' },
	section: { color: 'white', textAlign: 'center', margin: 30 },
	title: {
		fontSize: 25,
		marginVertical: 2,
		textAlign: 'center',
		color: '#9c7b53',
		height: 35,
		paddingTop: 15,
		fontWeight: 1000,
	},
	dateTitle: {
		fontSize: 22,
		marginVertical: 2,
		textAlign: 'center',
		color: '#9c7b53',
		height: 30,
		fontWeight: 1000,
	},
	graphLabelTitle: {
		fontSize: 10,
		textAlign: 'center',
		color: '#9c7b53',
		height: 18,
	},
	TableCellHeaderStyle : {
		padding: 5,
		textAlign: "center",
		fontSize: 14,
		fontWeight: 900,
		backgroundColor: '#ffffff'
	},
	TableCellBodyStyle : {
		padding: 5,
		textAlign: "center",
		fontSize: 11,
		backgroundColor: '#f3c12b'
	},
	TableStyle : {
		padding: 5,
	},
	Table: {
		marginVertical: 5,
		marginHorizontal: 5,
	},
	image: {
		marginVertical: 0,
		marginHorizontal: 0,
	},
	graphLabelContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	graphLabelLeftContainer: {
		width: '51.5px',
	},
	graphLabelTitleContainer: {
		width: '169.75px',
		marginHorizontal: 0
	},
	graphLabelRightContainer: {
		width: '51.5px',
		marginRight: '1.6px'
	},
	serialContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	serialLeftContainer: {
		width: '51.5px',
	},
	serialCenterContainer: {
		width: '495px'
	},
	serialRightContainer: {
		width: '51.5px',
		marginRight: '0.75px'
	},
	edgeImage: {
		width: 51.5,
		height: 51.5
	},
	dateEdgeImage: {
		width: 51.5,
		height: 34
	},
	graphLabelEdgeImage: {
		width: 51.5,
		height: 18
	},
	graphContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	graphLeftContainer: {
		width: '43px',
		float: 'left',
		marginRight: 7
	},
	graphImageContainer: {
		width: '170px',
		marginHorizontal: 1.10,
		maxHeight: 200
	},
	graphRightContainer: {
		width: '43px',
		marginRight: '1.1px'
	},
	graphEdgeImage: {
		width: 43,
		height: 200
	},
	imageGraphOne: {
		marginVertical: 0,
		marginHorizontal: 0,
		backgroundColor: '#ff715b',
		width: '150px'
	},
	imageGraphTwo: {
		marginVertical: 0,
		marginHorizontal: 0,
		backgroundColor: '#6665dd',
		width: '150px'
	},
	imageGraphThree: {
		marginVertical: 0,
		marginHorizontal: 0,
		backgroundColor: '#33d1bf',
		width: '150px'
	},
	headerContainer: {
		textAlign: 'center',
		width: '100%',
		backgroundImage: `url('${certBG}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		height: "100px"
	},
});

class GenNovaCalibrationCert extends React.Component {
	render() {
		return (
			<Document>
				<Page size="A4" style={certStyles.page}>
					<Image style={certStyles.image} src={certPart1} />
					<View style={certStyles.serialContainer}>
						<View style={certStyles.serialLeftContainer}>
							<Image style={certStyles.edgeImage} src={certEdge} />
						</View>
						<View style={certStyles.serialCenterContainer}>
							<Text style={certStyles.title}>Serial: {this.props.serialNumber}</Text>
						</View>
						<View style={certStyles.serialRightContainer}>
							<Image style={certStyles.edgeImage} src={certEdgeRight} />
						</View>
					</View>
					<Image style={certStyles.image} src={certPart2} />
					<View style={certStyles.serialContainer}>
						<View style={certStyles.serialLeftContainer}>
							<Image style={certStyles.dateEdgeImage} src={certEdge} />
						</View>
						<View style={certStyles.serialCenterContainer}>
							<Text style={certStyles.dateTitle}>Date: {Moment(this.props.date).format("MM/DD/YYYY")}</Text>
						</View>
						<View style={certStyles.serialRightContainer}>
							<Image style={certStyles.dateEdgeImage} src={certEdgeRight} />
						</View>
					</View>
					<View style={certStyles.graphLabelContainer}>
						<View style={certStyles.graphLabelLeftContainer}>
							<Image style={certStyles.graphLabelEdgeImage} src={certEdge} />
						</View>
						<View style={certStyles.graphLabelTitleContainer}>
							<Text style={certStyles.graphLabelTitle}>810</Text>
						</View>
						<View style={certStyles.graphLabelTitleContainer}>
							<Text style={certStyles.graphLabelTitle}>980</Text>
						</View>
						<View style={certStyles.graphLabelTitleContainer}>
							<Text style={certStyles.graphLabelTitle}>DUAL</Text>
						</View>
						<View style={certStyles.graphLabelRightContainer}>
							<Image style={certStyles.graphLabelEdgeImage} src={certEdgeRight} />
						</View>
					</View>
					<View style={certStyles.graphContainer}>
						<View style={certStyles.graphLeftContainer}>
							<Image style={certStyles.graphEdgeImage} src={certGraphLeftEdge} />
						</View>
						<View style={certStyles.graphImageContainer}>
							<Image style={certStyles.imageGraphOne} src={this.props.chartImage1} />
						</View>
						<View style={certStyles.graphImageContainer}>
							<Image style={certStyles.imageGraphTwo} src={this.props.chartImage2} />
						</View>
						<View style={certStyles.graphImageContainer}>
							<Image style={certStyles.imageGraphThree} src={this.props.chartImage3} />
						</View>
						<View style={certStyles.graphRightContainer}>
							<Image style={certStyles.graphEdgeImage} src={certGraphRightEdge} />
						</View>
					</View>
					<Image style={certStyles.image} src={certPart3} />
				</Page>
			</Document>
		);
	}
}

class NovaCalibration extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			currentUser: JSON.parse(localStorage.getItem("currentUser")) || authenticationService.currentUserValue,
			deviceList: this.getStoredDeviceList(),
			devices: [],
			serialNumbers: [],
			currentItem: "",
			hasChartData: false,
			chartDateLastModified: "",
			overallResult: "",
			chartData810: {},
			chartData980: {},
			chartDataDual: {},
			lineOptions1: {},
			lineOptions2: {},
			lineOptions3: {},
			modal: false,
		};

		this.toggle = this.toggle.bind(this);
	}

	async componentDidMount() {
		this.setOptions();
		await this.getNovaSerials();
	}

	setOptions() {
		const getOptions = (imageIndex) => ({
			maintainAspectRatio: false,
			legend: {
				display: false,
				labels: { fontFamily: "Nunito Sans" }
			},
			plugins: {
				datalabels: {
					display: true,
					color: "black",
					align: "end",
					anchor: "end",
					font: { size: "14", weight: "bold" }
				}
			},
			scales: {
				yAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						beginAtZero: true,
						fontFamily: "Nunito Sans",
						fontColor: "#000"
					}
				}],
				xAxes: [{
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						fontFamily: "Nunito Sans",
						fontColor: "#000"
					}
				}]
			},
			animation: {
				onComplete: function(event) {
					if (imageIndex==1) {
						image1 = this.toBase64Image();
					} else if (imageIndex==2) {
						image2 = this.toBase64Image();
					} else if (imageIndex==3) {
						image3 = this.toBase64Image();
					}

					imageCount = imageCount+1;
					if (imageCount>2) {
						hasImages = true;
					}
				}
			}
		});

		this.setState({
			lineOptions1: getOptions(1),
			lineOptions2: getOptions(2),
			lineOptions3: getOptions(3)
		});
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	getCertificateDocument = () => {
		return (
			<GenNovaCalibrationCert
				serialNumber={this.state.currentItem}
				chartImage1={image1}
				chartImage2={image2}
				chartImage3={image3}
				date={this.state.chartDateLastModified}
			/>
		);
	}

	printPdfBlobInPlace = (blob, options = {}) => {
		const {
			printDelayMs = 1200
		} = options;

		const printUrl = URL.createObjectURL(blob);
		const iframe = document.createElement("iframe");

		iframe.setAttribute("aria-hidden", "true");
		iframe.style.position = "fixed";
		iframe.style.right = "0";
		iframe.style.bottom = "0";
		iframe.style.width = "1px";
		iframe.style.height = "1px";
		iframe.style.opacity = "0";
		iframe.style.pointerEvents = "none";
		iframe.style.border = "0";

		const cleanup = () => {
			if (iframe.parentNode) {
				iframe.parentNode.removeChild(iframe);
			}
			URL.revokeObjectURL(printUrl);
			window.removeEventListener("afterprint", cleanup);
		};

		iframe.onload = () => {
			window.setTimeout(() => {
				try {
					if (iframe.contentWindow) {
						iframe.contentWindow.focus();
						iframe.contentWindow.print();
						window.addEventListener("afterprint", cleanup, { once: true });
						window.setTimeout(cleanup, 60000);
						return;
					}
				} catch (error) {}

				cleanup();
				window.alert("Unable to print this calibration certificate.");
			}, printDelayMs);
		};

		iframe.src = printUrl;
		document.body.appendChild(iframe);
	};

	printCalibrationCertificate = async () => {
		try {
			const blob = await pdf(this.getCertificateDocument()).toBlob();
			this.printPdfBlobInPlace(blob, { printDelayMs: 1200 });
		} catch (error) {
			window.alert("Unable to prepare this calibration certificate for printing.");
		}
	}

	getSerialRows(body) {
		if (Array.isArray(body)) {
			return body;
		}

		return body.results || body.response || body.serials || [];
	}

	getStoredDeviceList() {
		try {
			return JSON.parse(localStorage.getItem("deviceList")) || [];
		} catch (err) {
			console.log("Unable to parse deviceList: " + err);
			return [];
		}
	}

	getUserRole() {
		if (this.state.currentUser && this.state.currentUser.payload && this.state.currentUser.payload["custom:role"]) {
			return parseInt(this.state.currentUser.payload["custom:role"]);
		}

		if (this.state.currentUser && this.state.currentUser.role) {
			return parseInt(this.state.currentUser.role);
		}

		return 0;
	}

	isSupportUser() {
		return this.getUserRole()>0;
	}

	isNovaSerial = (device) => {
		const productID = device.Product || device.product || device.ProductID || device.productID || device.productid || device.ProductId || device.productId;
		return productID==2 || productID=="2";
	};

	setNovaSerialOptions = (devices) => {
		const serialNumbers = devices.map(device => String(device.SerialNumber));

		this.setState({ devices, serialNumbers });

		const location = window.location;
		const query = new URLSearchParams(location.search);
		const querySerial = query.get("serial");
		const initialSerial = querySerial && serialNumbers.includes(querySerial) ? querySerial : serialNumbers[0];

		if (initialSerial) {
			this.setState({ currentItem: initialSerial });
			this.getCalibrationData(initialSerial);
		} else {
			this.setState({ currentItem: "", hasChartData: false });
		}
	};

	getNovaSerials = async () => {
		if (!this.isSupportUser()) {
			var userDeviceUrl = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"device-list";

			try {
				const response = await fetch(userDeviceUrl, {
					method: "GET",
					headers: {
						Authorization: this.state.currentUser.jwtToken
					},
				});

				const body = await response.json();
				console.log("registered Nova calibration serials: " + JSON.stringify(body));

				const registeredDevices = body.status == "Success" ? this.getSerialRows(body) : this.state.deviceList;
				const registeredNovaDevices = registeredDevices.filter(device => device.SerialNumber && this.isNovaSerial(device));
				this.setNovaSerialOptions(registeredNovaDevices);
			}
			catch (err) {
				console.log(err);
				const registeredNovaDevices = this.state.deviceList.filter(device => device.SerialNumber && this.isNovaSerial(device));
				this.setNovaSerialOptions(registeredNovaDevices);
			}

			return;
		}

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com/v1/all-serials?ProductID=2";

		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all Nova calibration serials: " + JSON.stringify(body));

			if (body.status == "Success" || this.getSerialRows(body).length>0) {
				const devices = this.getSerialRows(body).filter(device => device.SerialNumber && this.isNovaSerial(device));
				this.setNovaSerialOptions(devices);
			} else {
				this.setState({ devices: [], serialNumbers: [], hasChartData: false });
			}
		}
		catch (err) {
			console.log(err);
			this.setState({ devices: [], serialNumbers: [], hasChartData: false });
		}
	};

	getCalibrationData = async (serial) => {
		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-calibration-data?ProductID=2&SerialNumber="+serial;

		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("get Nova calibration data body: " + JSON.stringify(body));

			if (body.status == "Success" && body.response && body.response.waveform_results) {
				this.setChartData(body);
			} else {
				this.setState({ hasChartData: false, chartData810: {}, chartData980: {}, chartDataDual: {} });
			}
		}
		catch (err) {
			console.log(err);
			this.setState({ hasChartData: false, chartData810: {}, chartData980: {}, chartDataDual: {} });
		}
	};

	setChartData(body) {
		image1 = null;
		image2 = null;
		image3 = null;
		imageCount = 0;
		hasImages = false;

		const waveformResults = body.response.waveform_results || [];
		const result810 = waveformResults.find(result => String(result.wavelength).toLowerCase()=="810");
		const result980 = waveformResults.find(result => String(result.wavelength).toLowerCase()=="980");
		const resultDual = waveformResults.find(result => String(result.wavelength).toLowerCase()=="dual");

		this.setState({
			hasChartData: true,
			overallResult: body.response.overall_result || "",
			chartDateLastModified: body.lastModified || body.response.timestamp || "",
			chartData810: this.getBarChartData(result810),
			chartData980: this.getBarChartData(result980),
			chartDataDual: this.getBarChartData(resultDual),
		});
	}

	getBarChartData(result) {
		if (!result) {
			return { labels: [], datasets: [] };
		}

		return {
			labels: ["Target Avg W", "Measured Avg W", "Peak W"],
			datasets: [{
				label: "Power",
				backgroundColor: "#000",
				data: [
					Number(result.power_target_W).toFixed(2),
					Number(result.measured_power_W).toFixed(2),
					Number(result.peak_power_W).toFixed(2)
				]
			}]
		};
	}

	onChangeSerialNumberAutoComplete = (event, value) => {
		console.log("onChangeSerialNumber value: " + value);

		if (value != null) {
			this.setState({ currentItem: value });
			this.getCalibrationData(value);
		}
	};

	renderChartCard(title, chartData, options, backgroundColor) {
		return (
			<Col md="12" lg="6" xl="4">
				<Card style={{ backgroundColor }} className="card-hover">
					<CardBody>
						<Row className="mb-3">
							<Col md="8">
								<h3 style={{color:"#000"}}>{title}</h3>
							</Col>
							<Col md="4" className="text-right">
								{this.state.hasChartData &&
									<h3 style={{color:"#000", lineHeight: "0.8"}}><i className="mdi mdi-verified mdi-36px" /></h3>
								}
							</Col>
						</Row>
						<Row className="mb-3">
							{this.state.hasChartData ? (
								<Fragment>
									<Col md="12">
										<Bar height={500} data={chartData} options={options} />
									</Col>
								</Fragment>
							) : (
								<Fragment>
									<Col md="12">
										<h4 className="mt-5 mb-5 p-5" style={{color:"#000", textAlign: "center"}}>No Calibration Data for Serial: {this.state.currentItem}</h4>
									</Col>
								</Fragment>
							)}
						</Row>
						{this.state.hasChartData &&
							<Row className="">
								<Col md="12">
									<h5 className="text-center" style={{color:"#000"}}>Power Displayed in Watts</h5>
								</Col>
							</Row>
						}
					</CardBody>
				</Card>
			</Col>
		);
	}

	render() {
		return (
			<Fragment>
				<Row className="mb-3">
					<Col xs="4">
						<h1 style={{color:"#737782"}}>Nova Calibration</h1>
					</Col>
					<Col xs="12" sm="8" className="text-right">
						{this.state.currentItem!="" && this.state.hasChartData &&
							<div className="float-right" style={{ width: "175px" }}>
								<Button className="ml-3" size="md" color="dark" title="PRINT CERT" onClick={() => {this.toggle()}}>
									Download Certificate
								</Button>
							</div>
						}
						<div className="float-right" style={{ width: "175px" }}>
							<ThemeProvider theme={theme}>
								<AutoCompleteInput
									value={this.state.currentItem ? this.state.currentItem : ""}
									onChange={this.onChangeSerialNumberAutoComplete}
									getItemValue={(item) => item.name}
									name="SerialNum"
									id="SerialNum"
									options={this.state.serialNumbers}
									getOptionLabel={(option) => option}
									style={{ width: "100%", color: "#b2b9bf" }}
									renderInput={(params) => <TextField {...params} />}
								/>
							</ThemeProvider>
						</div>
						<div className="float-right" style={{ width: "80px" }}>
							<h3 className="pr-2" style={{color:"#737782"}}>Serial:</h3>
						</div>
					</Col>
				</Row>
				{this.state.hasChartData &&
					<Row>
						<Col>
							<h4 style={{color:"#737782"}}>Date: {Moment(this.state.chartDateLastModified).format("MM/DD/YYYY")}</h4>
							{this.state.overallResult &&
								<h4 style={{color:"#737782"}}>Overall Result: {this.state.overallResult}</h4>
							}
						</Col>
					</Row>
				}
				<Row className="mb-3">
					<Col md="12">
						<h4 style={{color:"#737782"}}>The information shown below is the actual peak and average power in watts of your Nova device after factory calibration.</h4>
						<h4 style={{color:"#737782"}}>Re-calibration is recommended every 12 months in order to assure accuracy of optical power output.</h4>
					</Col>
				</Row>
				<Row className="mb-3">
					{this.renderChartCard("810 Wavelength", this.state.chartData810, this.state.lineOptions1, "#ff715b")}
					{this.renderChartCard("980 Wavelength", this.state.chartData980, this.state.lineOptions2, "#6665dd")}
					{this.renderChartCard("DUAL Wavelength", this.state.chartDataDual, this.state.lineOptions3, "#33d1bf")}
				</Row>
				<div>
					<Modal isOpen={this.state.modal} toggle={this.toggle}>
						<ModalHeader toggle={this.toggle}>Calibrartion Certificate</ModalHeader>
						<ModalBody>
							<PDFViewer style={{ height: "730px", width: "100%"}}>
								{this.getCertificateDocument()}
							</PDFViewer>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" className="ml-1" onClick={this.toggle}>OK</Button>
							<Button color="primary" className="ml-1" onClick={this.printCalibrationCertificate}>Print</Button>
						</ModalFooter>
					</Modal>
				</div>
			</Fragment>
		);
	}
}

export default NovaCalibration;
